import urlLocationHelper from '@/scripts/helpers/url-location-helper';
import { UTMParameters } from '../../common-parameters';

type QueryParameterContainingUTMParameters = {
  [T in UTMParameters | string]?: string;
}

export const checkParameterRequirements = (): boolean => {
  const query = urlLocationHelper.query.parse() as QueryParameterContainingUTMParameters;
  const campaign = query[UTMParameters.Campaign];
  const source = query[UTMParameters.Source];
  const medium = query[UTMParameters.Medium];

  if (campaign && campaign.startsWith('paid-')) {
    return false;
  }

  if (!source) {
    return false;
  }

  if (!['cmarketing', 'cmarketingID'].includes(source)) {
    return false;
  };

  if (!medium) {
    return false;
  }

  return [
    'BuzzEN',
    'fbcomment',
    'fbcover',
    'fblink',
    'fbteaser',
    'ffupload',
    'filmpage',
    'FilmKOLID',
    'IGfeedEN',
    'IGStoryEN',
    'newsletter',
    'twitterEN',
    'webpushEN',
    'YTAdwords',
  ].includes(medium);
};
